import fetch from '@/common/js/http';

const project = {
    namespaced: true,
    mutations: {},
    actions: {
        getAllProject({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'project/all',
                    method: 'get',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getlistWithPage({commit}, {pageSize, pageNum, search, projectId,progressStart,progressEnd}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'project/page',
                    method: 'get',
                    params: {
                        pageSize: pageSize,
                        pageNum: pageNum,
                        projectName: search,
                        projectId: projectId,
                        progressStart:progressStart,
                        progressEnd:progressEnd
                    }
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        createProject({commit}, proj) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'project',
                    method: 'put',
                    data: proj
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        saveProject({cmmmit}, proj) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'project',
                    method: 'post',
                    data: proj
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        deleteProject({cmmmit}, id) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'project/' + id,
                    method: 'delete',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
    }
}

export default project



// WEBPACK FOOTER //
// ./src/vuex/modules/project.js